var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("UserLimit"),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-6 mb-2" },
          [
            _c("Search", {
              ref: "search",
              attrs: {
                suggestions: _vm.suggestions,
                placeholder: _vm.$t("activitySearchToolTip")
              },
              on: { search: _vm.onSearch }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-6" },
          [
            _c("div", { staticClass: "float-right" }, [
              _vm.actionsStore.definitions.length
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-secondary",
                      on: {
                        click: function($event) {
                          return _vm.$refs.actionTriggerModal.open()
                        }
                      }
                    },
                    [
                      _c("i", {
                        staticClass: "fas fa-bolt",
                        staticStyle: { color: "#ff9900" }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "font-weight-bold small" }, [
                        _vm._v(_vm._s(_vm.$t("activityActions")))
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isAiEnabled()
                ? _c(
                    "button",
                    {
                      staticClass: "btn",
                      on: {
                        click: function($event) {
                          return _vm.$refs.askModal.open()
                        }
                      }
                    },
                    [_c("i", { staticClass: "fas fa-magic" })]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._m(0)
            ]),
            _vm._v(" "),
            _c("TriggerModal", { ref: "actionTriggerModal" })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("Vuetable", {
        ref: "vuetable",
        attrs: {
          "api-url": "api/activity/activities",
          "data-path": "activities.data",
          "pagination-path": "activities",
          "append-params": _vm.moreparams,
          fields: _vm.fields,
          transform: _vm.transformToOpenApi,
          "first-page": 0,
          initialPage: 0,
          "per-page": 10
        },
        on: {
          "vuetable:pagination-data": _vm.onPaginationData,
          "vuetable:checkbox-toggled": _vm.onSelectionChanged,
          "vuetable:checkbox-toggled-all": _vm.onSelectionChanged
        },
        scopedSlots: _vm._u([
          {
            key: "tableHeader",
            fn: function({ fields }) {
              return [
                _c("VuetableCustomHeader", {
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "tableHeaderFieldHtml_fkUserResponsibleName",
                        fn: function({ field }) {
                          return _c(
                            "div",
                            {},
                            [
                              _c("span", {
                                domProps: { innerHTML: _vm._s(field.title) }
                              }),
                              _vm._v(" "),
                              _c("v-select", {
                                attrs: { options: _vm.distinctResponsibles },
                                model: {
                                  value: _vm.permanentSearchResponsibleUserName,
                                  callback: function($$v) {
                                    _vm.permanentSearchResponsibleUserName = $$v
                                  },
                                  expression:
                                    "permanentSearchResponsibleUserName"
                                }
                              })
                            ],
                            1
                          )
                        }
                      },
                      {
                        key: "tableHeaderFieldHtml_reference",
                        fn: function({ field }) {
                          return _c(
                            "div",
                            {},
                            [
                              _c("span", {
                                domProps: { innerHTML: _vm._s(field.title) }
                              }),
                              _vm._v(" "),
                              _c("v-select", {
                                attrs: { options: _vm.distinctReferences },
                                model: {
                                  value: _vm.permanentSearchReference,
                                  callback: function($$v) {
                                    _vm.permanentSearchReference = $$v
                                  },
                                  expression: "permanentSearchReference"
                                }
                              })
                            ],
                            1
                          )
                        }
                      },
                      {
                        key: "tableHeaderFieldHtml_techArea",
                        fn: function({ field }) {
                          return _c(
                            "div",
                            {},
                            [
                              _c("span", {
                                domProps: { innerHTML: _vm._s(field.title) }
                              }),
                              _vm._v(" "),
                              _c("v-select", {
                                attrs: { options: _vm.distinctTechAreas },
                                model: {
                                  value: _vm.permanentSearchTechArea,
                                  callback: function($$v) {
                                    _vm.permanentSearchTechArea = $$v
                                  },
                                  expression: "permanentSearchTechArea"
                                }
                              })
                            ],
                            1
                          )
                        }
                      },
                      {
                        key: "tableHeaderFieldHtml_actions",
                        fn: function({ field }) {
                          return [
                            _vm._v(
                              "\n          " +
                                _vm._s(field.title) +
                                "\n          "
                            ),
                            _c("div", { staticClass: "d-inline float-right" }, [
                              _vm.hiddenColumnWithActivePermanentSearch.length
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "badge badge-pill badge-warning"
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa fa-filter",
                                        attrs: {
                                          title:
                                            _vm.$t(
                                              "activityHiddenColumnWithActivePermanentSearch"
                                            ) +
                                            ":\n" +
                                            _vm.hiddenColumnWithActivePermanentSearchString
                                        }
                                      })
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("i", {
                                staticClass: "fa fa-ellipsis-v c-pointer",
                                attrs: {
                                  id: "optionsDropdownButton",
                                  "data-toggle": "dropdown",
                                  "aria-haspopup": "true",
                                  "aria-expanded": "false"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "dropdown-menu",
                                  attrs: {
                                    "aria-labelledby": "#optionsDropdownButton"
                                  }
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item c-pointer",
                                      attrs: {
                                        "data-toggle": "modal",
                                        "data-target": "#columnSelector"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.$t("activityColumns")) +
                                          "\n              "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item c-pointer",
                                      on: {
                                        click: function($event) {
                                          _vm.showCheckboxes = !_vm.showCheckboxes
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t("activityMassSelection")
                                          ) +
                                          "\n              "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.showCheckboxes &&
                                  _vm.selectedActivities.length > 0
                                    ? [
                                        _c("div", {
                                          staticClass: "dropdown-divider"
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "dropdown-item c-pointer",
                                            attrs: {
                                              "data-toggle": "modal",
                                              "data-target":
                                                "#userselectmodalmassselect"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "activityAssignResponsible"
                                                  )
                                                ) +
                                                "\n                "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "dropdown-item c-pointer",
                                            on: { click: _vm.onMassClose }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.$t("activityClose")
                                                ) +
                                                "\n                "
                                            )
                                          ]
                                        )
                                      ]
                                    : _vm._e()
                                ],
                                2
                              )
                            ])
                          ]
                        }
                      }
                    ],
                    null,
                    true
                  )
                })
              ]
            }
          },
          {
            key: "cellParents",
            fn: function(props) {
              return _c("div", {}, [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      [...props.rowData.cellParents]
                        .concat(props.rowData.cellName)
                        .join(" > ")
                    ) +
                    "\n    "
                )
              ])
            }
          },
          {
            key: "actions",
            fn: function(props) {
              return _c("div", {}, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary btn-sm",
                    attrs: { title: _vm.$t("activityModal.open") },
                    on: {
                      click: function($event) {
                        return _vm.onActionClicked(props.rowData)
                      }
                    }
                  },
                  [_c("i", { staticClass: "fas fa-eye" })]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary btn-sm",
                    attrs: { title: _vm.$t("activityModal.share") },
                    on: {
                      click: function($event) {
                        return _vm.onActionOpenModal(props.rowData)
                      }
                    }
                  },
                  [_c("i", { staticClass: "fas fa-share" })]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary btn-sm",
                    on: {
                      click: function($event) {
                        return _vm.onExport(props.rowData)
                      }
                    }
                  },
                  [_c("i", { staticClass: "fa fa-file-export" })]
                )
              ])
            }
          }
        ])
      }),
      _vm._v(" "),
      _c("VuetablePagination", {
        ref: "pagination",
        attrs: { "first-page": 0, css: _vm.mycss.pagination },
        on: { "vuetable-pagination:change-page": _vm.onChangePage }
      }),
      _vm._v(" "),
      _c("VuetablePaginationInfo", {
        ref: "paginationinfo",
        attrs: {
          "first-page": 0,
          css: _vm.mycss.pagination,
          infoTemplate: _vm.$t("vuetablePaginationInfoTemplate"),
          noDataTemplate: _vm.$t("vuetablePaginationNoDataTemplate")
        }
      }),
      _vm._v(" "),
      _c("ColumnSelectorModal", {
        attrs: {
          modalId: "columnSelector",
          availableColumns: _vm.availableFields,
          selectedColumns: _vm.selectedFields
        },
        on: {
          selectedColumn: _vm.onColumnSelected,
          unselectedColumn: _vm.onColumnUnselected
        }
      }),
      _vm._v(" "),
      _c("ActivityModal", {
        ref: "activityInfoModal",
        attrs: {
          duty: _vm.duty,
          activity: _vm.activity,
          availableResponsibles: _vm.availableResponsibles,
          availablePriorities: _vm.availablePriorities,
          cells: _vm.cells
        }
      }),
      _vm._v(" "),
      _c("FlowModal", {
        ref: "flowModal",
        attrs: { modalId: "flowModal", createFlow: _vm.createFlow }
      }),
      _vm._v(" "),
      _c("UserSelectModal", {
        ref: "userselectmodalmassselect",
        attrs: {
          modalId: "userselectmodalmassselect",
          available: _vm.availableResponsibles,
          selected: _vm.selectedResponsible
        },
        on: { selected: _vm.onResponsibleChanged }
      }),
      _vm._v(" "),
      _vm.isAiEnabled() ? _c("AskModal", { ref: "askModal" }) : _vm._e(),
      _vm._v(" "),
      _c("div", { attrs: { id: "search-component" } }, [_vm._v("Loading...")])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "button",
      {
        staticClass: "btn",
        attrs: { "data-toggle": "modal", "data-target": "#searchModal" }
      },
      [_c("i", { staticClass: "fas fa-bell" })]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }